// extracted by mini-css-extract-plugin
export var center = "Section-module--center--b4080";
export var inner = "Section-module--inner--2d004";
export var padding = "Section-module--padding--57e37";
export var paddingBottomL = "Section-module--paddingBottomL--4e7c9";
export var paddingBottomM = "Section-module--paddingBottomM--324c8";
export var paddingBottomS = "Section-module--paddingBottomS--fe566";
export var paddingBottomXl = "Section-module--paddingBottomXl--7e14a";
export var paddingL = "Section-module--paddingL--d11ad";
export var paddingM = "Section-module--paddingM--841fe";
export var paddingS = "Section-module--paddingS--db32f";
export var paddingTopL = "Section-module--paddingTopL--5f003";
export var paddingTopM = "Section-module--paddingTopM--45133";
export var paddingTopS = "Section-module--paddingTopS--82f42";
export var paddingTopXl = "Section-module--paddingTopXl--210d5";
export var paddingXl = "Section-module--paddingXl--cf99c";
export var themeBlue = "Section-module--themeBlue--a7bfd";
export var themeDark = "Section-module--themeDark--3c017";
export var themeGrey = "Section-module--themeGrey--0f433";
export var themeGreyBlue = "Section-module--themeGreyBlue--4b3b5";
export var themeIndigo = "Section-module--themeIndigo--99c04";
export var themeWave = "Section-module--themeWave--4dac4";
export var waveBottom = "Section-module--waveBottom--17d16";
export var waveTop = "Section-module--waveTop--ea78c";